module.exports = __webpack_public_path__ + "img/bingo_ball-33.29e9ce8e.png";